const SearchFormTable = ({ pills, tableColumns, tableRows }) => {
  return (
    <>
      <div className="d-block d-sm-flex justify-content-between my-4">
        <div>
          {pills.map((item) => (
            <button
              className={`mb-2 ms-2 btn btn-${item.variant} wt-disable-link`}
              key={item.id}
            >
              {item.title}
              <span className="badge badge-pill badge-light mx-2">
                {item.value}
              </span>
            </button>
          ))}
        </div>
        <button className="btn btn-outline-primary mb-2 mr-2 btn btn-outline-primary page-title-action">
          Export
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover text-center align-middle w-100">
          <thead className="table-dark">
            <tr>
              {tableColumns.map((item) => (
                <td key={item.id}>{item.name}</td>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableRows.map((item) => (
              <tr key={item.id}>
                <td>{item.col1}</td>
                <td>{item.col2}</td>
                <td>{item.col3}</td>
                <td>{item.col4}</td>
                <td>{item.col5}</td>
              </tr>
            ))}
          </tbody>
          <tfoot className="table-dark">
            <tr>
              {tableColumns.map((item) => (
                <td key={item.id}>{item.name}</td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default SearchFormTable;
